import { render, staticRenderFns } from "./kycPreferences.vue?vue&type=template&id=06e62e03&scoped=true"
import script from "./kycPreferences.vue?vue&type=script&lang=js"
export * from "./kycPreferences.vue?vue&type=script&lang=js"
import style0 from "./kycPreferences.vue?vue&type=style&index=0&id=06e62e03&prod&scoped=true&lang=css"
import style1 from "./kycPreferences.vue?vue&type=style&index=1&id=06e62e03&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e62e03",
  null
  
)

export default component.exports